<template lang="pug">
  div
    div
      button.change-button(
        @click="openModal"
        :disabled="disabled"
      )
        | Rechazo Administrativo

    b-modal(
      v-model="showModal"
      title="Rechazo Administrativo"
      centered
      hide-footer
      @hidden="resetForm"
    )
      p.mb-3 Selecciona el motivo por el cual se está rechazando esta Orden de Trabajo, puedes ingresar un comentario si es necesario.
      
      b-form-group(
        label="Motivo*"
        label-for="motivo-select"
      )
        b-form-select(
          id="motivo-select"
          v-model="selectedMotivo"
          :options="motivosOptions"
          required
          @change="onMotivoChange"
        )
      b-form-group(
        v-if="showComentario"
        label="Comentario"
        label-for="comentario-input"
      )
        b-form-textarea(
          id="comentario-input"
          v-model.trim="comentario"
          placeholder="Ingresa un Comentario"
          rows="3"
          max-rows="6"
        )

      .d-flex.justify-content-center.mt-4
        b-button(
          variant="primary"
          @click="confirmarRechazo"
          :disabled="loading || !selectedMotivo || (showComentario && !comentario.trim())"
        )
          b-spinner(v-if="loading" small)
          span {{ loading ? 'Procesando...' : 'Confirmar Rechazo' }}
        
      b-modal(
        ref="confirmModal"
        @shown="onModalShown"
        @hide="onModalHide"
      )
</template>

<script>
import { mapActions } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'

export default {
  name: 'ActionRechazoAdministrativo',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],

  data() {
    return {
      showModal: false,
      selectedMotivo: null,
      comentario: '',
      motivosOptions: [
        { value: null, text: 'Selecciona un Motivo', disabled: true },
        { value: 'Boleta no corresponde con el equipo', text: 'Boleta no corresponde con el equipo' },
        { value: 'Cliente no firmó autorización de formateo', text: 'Cliente no firmó autorización de formateo' },
        { value: 'Falta documentación del cliente', text: 'Falta documentación del cliente' },
        { value: 'Otro motivo', text: 'Otro motivo' }
      ]
    }
  },
  methods: {
    ...mapActions('OTStore', ['rechazoAdministrativo']),
    
    openModal() {
      this.showModal = true;
    },
    
    onModalShown() {
      // Evento cuando se muestra el modal
    },
    
    onModalHide() {
      // Evento cuando se oculta el modal
    },
    
    resetForm() {
      this.selectedMotivo = null;
      this.comentario = '';
    },
    onMotivoChange(value) {
      if (value !== 'Otro motivo') {
        this.comentario = '';
      }
    },
    
    async confirmarRechazo() {
      if (!this.selectedMotivo) {
        return;
      }
      if (this.showComentario && !this.comentario.trim()) {
        return;
      }
      
      try {
        await this.executeWithLoading(async () => {
          const motivo_rechazo = this.motivoFinal;
          await this.rechazoAdministrativo({
            ot: this.ot.ot,
            motivo_rechazo,
            comentario_rechazo: this.comentario
          });

          this.$bvToast.toast('Orden de trabajo rechazada correctamente', {
            title: 'Rechazo Administrativo',
            variant: 'success',
            solid: true
          });
          
          this.showModal = false;
          this.$emit('action-completed');
        })
      } catch (error) {
        console.error('Error al rechazar OT:', error);
        this.$bvToast.toast('Error al rechazar la orden de trabajo', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    }
  },
  computed: {
    showComentario() {
      return this.selectedMotivo === 'Otro motivo';
    },
    motivoFinal() {
      return this.showComentario ? this.comentario.trim() : this.selectedMotivo;
    }
  },
}
</script>
